module.exports = __webpack_public_path__ + "img/ico_type_time.ab9d7cad.svg";